import React, { useEffect, useState } from 'react';
import { doc, getDoc, onSnapshot } from 'firebase/firestore';
import { auth, firestore} from "../../firebase/firebase.js";
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import remarkGfm from 'remark-gfm';
import rehypeLinks from 'rehype-external-links';
import styles from './MarkdownTabContent.module.css';

export default function MarkdownTabContent({ docId }) {
  const [content, setContent] = useState('');

  useEffect(() => {
		const unsubscribe = onSnapshot(doc(firestore, 'siteInfo', docId), (snapshot) => {
		  //setItems(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
		   setContent(snapshot.data().markdown || '');
		});

		return () => unsubscribe();
  }, [docId]);
  
 /* useEffect(() => {
    const fetchContent = async () => {
      const snap = await getDoc(doc(firestore, 'siteInfo', docId));
      if (snap.exists()) setContent(snap.data().markdown || '');
    };
    fetchContent();
  }, [docId]);*/

  return (
    <div className={styles.markdown}>
	  <ReactMarkdown rehypePlugins={[rehypeRaw, remarkGfm, rehypeLinks]}>{content}</ReactMarkdown>
    </div>
  );
}
